import { createRouter, createWebHistory } from 'vue-router'
import User from './components/other/User.vue'

import Img from './components/other/Img.vue'
import LayOut from "@/components/other/Layout.vue";

import Login from "@/components/other/login.vue";
import Message from "@/components/other/Message.vue";


import Read from "@/components/novel/Read.vue";

import ChatGpt from "@/components/other/ChatGpt.vue";
import Write from "@/components/novel/Writenovel.vue";
import Novelchapter from "@/components/novel/Novelchapter.vue";
import Gpt from './components/other/1.vue'
import Noveltype from "@/components/novel/Noveltype.vue";

import novels from "@/components/novel/novels.vue";
import Chaptertable from "@/components/novel/chaptertable.vue";
import NovelContent from "@/components/novel/NovelContent.vue";
import Qhome from "@/components/other/Qhome.vue";
import Home from "@/components/other/Home.vue";
import Info from "@/components/other/Info.vue";
import Comment from "@/components/other/Comment.vue";
import CarouselChart from "@/components/other/CarouselChart.vue";
import LogView from "@/components/other/LogView.vue";
const routes = [
    {
        path: '/1',
        name: '1',
        component: Gpt,

    },

    {
        path: '/qhome',
        name: 'qhome',
        redirect:'/novels',
        component: Qhome,
        children: [


            {
                path: '/message',
                name: 'messagr',
                component: Message
            },
            {
                path: '/img',
                name: 'img',
                component: Img,
            },
            {
                path: '/novels',
                name: 'novels',
                component: novels
            },
            {
                path: '/info',
                name: 'info',
                component: Info
            },

        ]

    },

    {
        path: '/LayOut',
        name: 'LayOut',
        component: LayOut,
        redirect:'/home',
        children: [ {
            path: '/user',
            name: 'user',
            component: User
        },
            {
                path: '/home',
                name: 'home',
                component: Home
            },




            {
                path: '/gpt',
                name: 'gpt',
                component: ChatGpt
            },

            {
                path: '/read',
                name: 'read',
                component: Read,
            },
            {
                path:'/noveltype',
                name: 'noveltype',
                component: Noveltype

            },
            {
                path: '/write',
                name: 'write',
                component: Write,
            },
            {
                path: '/novelchapters',
                name: 'novelchapters',
                component: Novelchapter,

            },
            {
                path: '/comment',
                name: 'Comment',
                component: Comment,
            },
            {
                path: '/chaptertable',
                name: "chaptertable",
                component: Chaptertable
            },
            {
                path: '/carouselChart',
                name: "CarouselChart",
                component: CarouselChart
            },
            {
                path: "/logview",
                name: "LogView",
                component: LogView
            }


        ]
    },
    {
        path: '/',
        name: 'login',
        component: Login,
    },
    {
        path: '/novelcontent',
        name: 'NovelContent',
        component: NovelContent,
    },



]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router